module.exports = __webpack_public_path__ + "static/img/category_50.fe4cc62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_50.jpg
// module id = fmh1
// module chunks = 0